package one.healthium.onboarding.di

import one.healthium.onboarding.ui.OnboardingViewModel
import one.healthium.onboarding.ui.UserUiMapper
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val onboardingModule = module {
    includes(onboardingDataModule, onboardingCommonModule)
    viewModelOf(::OnboardingViewModel)

    factoryOf(::UserUiMapper)
}